import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { CronFormatter } from '@bingads-webui/cron-formatter';
import { Frequency } from './frequency';
import { Extra } from './extra/extra';
import { getCronModel } from './get-cron-model';
import { getDefaultCron } from './get-default-cron';

export const CronFrequencyEditor = memo(({
  id,
  cron,
  i18n,
  enabledFrequencies,
  onChange,
  ariaLabelledby,
}) => {
  const [selectedCron, setCron] = useState(cron);

  const cronFormatter = new CronFormatter({ i18n });
  const onChangeCron = (newCron) => {
    onChange(newCron);
    setCron(newCron);
  };
  const onChangeFrequency = frequency =>
    onChangeCron(getDefaultCron(cronFormatter, frequency));

  const {
    frequency,
  } = getCronModel(cronFormatter, cron);

  return (
    <React.Fragment>
      <Frequency
        id={id}
        className="cron-frequency-editor__frequency"
        cronFormatter={cronFormatter}
        i18n={i18n}
        enabledFrequencies={enabledFrequencies}
        onChange={onChangeFrequency}
        selected={frequency}
        ariaLabelledby={ariaLabelledby}
      />
      <Extra
        classNamePrefix="cron-frequency-editor"
        cronFormatter={cronFormatter}
        cron={selectedCron}
        i18n={i18n}
        onChange={onChangeCron}
        ariaLabelledby={ariaLabelledby}
      />
    </React.Fragment>
  );
});

CronFrequencyEditor.propTypes = {
  id: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  cron: PropTypes.string,
  enabledFrequencies: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
  ariaLabelledby: PropTypes.string,
};

CronFrequencyEditor.defaultProps = {
  id: undefined,
  cron: undefined,
  enabledFrequencies: undefined,
  ariaLabelledby: '',
};
